import {
  GetStalledPlatformMessagesParams,
  PaginatedPlatformMessageStalledMessagesListItemsDTO,
  useGetStalledPlatformMessages,
} from "@bvhi/backend-api";
import { GridPaginationModel, GridSortModel } from "@bvhi/ui-base";
import { keepPreviousData } from "@tanstack/react-query";
import { forwardRef } from "react";
import { useStalledMessagesDataGridDefinitions } from "../hooks/use-stalled-messages-data-grid-definitions";
import { useMessagesSortParams } from "../hooks/use-messages-sort-params";
import { toNarrowedTypeOrNull } from "../../../../../utils/ts";
import { BVHIDataGrid } from "../../../../../components/datagrid/bvhi-datagrid";

interface Props {
  requestParams: GetStalledPlatformMessagesParams;
  updateCallback: (paginationModel: GridPaginationModel, sortModel: GridSortModel) => void;
}

export const StalledMessagesDataGrid = forwardRef<HTMLDivElement, Props>(({ requestParams, updateCallback }, ref) => {
  const { getSortModelForBackendString } = useMessagesSortParams();
  const { columns } = useStalledMessagesDataGridDefinitions();

  const { data, isFetching } = useGetStalledPlatformMessages(requestParams, {
    query: { throwOnError: (error) => error.status === 500 || error.status === 403, placeholderData: keepPreviousData },
  });

  const messages = toNarrowedTypeOrNull<PaginatedPlatformMessageStalledMessagesListItemsDTO>(data?.data, "numberOfItems");

  return (
    <div ref={ref}>
      <BVHIDataGrid
        columns={columns}
        initalPaginationModel={{ page: 0, pageSize: 25 }}
        initialSortModel={getSortModelForBackendString("")}
        loading={isFetching}
        rowCount={messages?.numberOfItems ?? -1}
        rows={messages?.payload ?? []}
        totalPages={messages?.numberOfPages ?? 0}
        updateCallback={updateCallback}
      />
    </div>
  );
});
StalledMessagesDataGrid.displayName = "StalledMessagesDataGrid";
